import React from 'react'
import Person from './person'
import { contentId } from '@uswitch/ev-utils/lib/contentful'
import { RichText } from '@uswitch/ev-core/react'
import { useEntity } from '@uswitch/ev-utils/lib/context/selectors'

const WrappedPerson = props => {
  const image = useEntity(contentId(props.image))
  const url = image?.file.url || ''

  return <Person {...props} bio={<RichText content={props.bio?.content} />} image={url}></Person>
}

export default WrappedPerson
